import {z} from 'zod';

export enum PersonStatus {
	IDENTIFIED = 'IDENTIFIED',
	UNIDENTIFIED = 'UNIDENTIFIED',
	HIDDEN = 'HIDDEN',
}

export const PersonSchema = z.object({
	id: z.string().uuid(),
	assetCount: z.number().int().nonnegative(),
	avatarUrl: z.string().nullable(),
	/** ex: 2026-05-21T17:59:40-07:00 */
	creationDate: z.string(),
	/** ex: 2026-05-21T17:59:40-07:00 */
	modificationDate: z.string(),
	name: z.string(),
	status: z.nativeEnum(PersonStatus),
});

export type IPerson = z.infer<typeof PersonSchema>;

export const PersonField = PersonSchema.keyof().enum;

export const PersonSetAvatarFormSchema = z.object({
	personId: z.string().nonempty(),
	faceId: z.string().nonempty(),
});

/**
 * Form values for identifying a person
 */
export type IPersonSetAvatarFormValues = z.infer<
	typeof PersonSetAvatarFormSchema
>;
